(function() {
	'use strict';

	var $ = avm.require('cash'),
		$tablesMore = $('.js-tables-showMore');


	// Tabs switcher
	$tablesMore.on('click', function(e) {
		e.preventDefault();
		var $self = $(this),
			$table = $self.closest('.js-tables'),
			$tableRows = $table.find('.js-tables-hidden');
		$self.hide();
		$tableRows.addClass('is-active');
	});

})();
